import { Box } from '@mui/material'

export type LogoHappaProps = {
  sx?: any
  href?: string
} & React.HTMLAttributes<HTMLAnchorElement>

const LogoHappa: React.FC<LogoHappaProps> = ({ href, ...props }) => {
  return (
    <Box component="a" href={href} {...props}>
      <Box
        component="svg"
        viewBox="0 0 467.21 111.72"
        sx={{
          display: 'block',
          width: { xs: '115%', sm: '100%' },
          height: { xs: '115%', sm: '100%' }
        }}
      >
        <path
          fill="#d3d800"
          d="M239.09,90.71c-6.46,0-12.51-1.77-17.69-4.83-1.82-1.08-3.54-2.32-5.12-3.7-7.32,6.37-11.95,15.76-11.95,26.23v3.32h17.07v-3.32c0-9.76,7.93-17.69,17.69-17.69"
        />
        <path
          fill="#00a04c"
          d="M216.27,82.17c-7.32-6.37-11.95-15.76-11.95-26.23v52.46c0-10.47,4.63-19.86,11.95-26.23"
        />
        <path
          fill="#0030e8"
          d="M273.85,55.94c0-19.2-15.56-34.76-34.76-34.76s-34.7,15.5-34.76,34.64v.11c0,10.47,4.63,19.86,11.95,26.23,1.59-1.38,3.3-2.62,5.12-3.7,5.18-3.07,11.23-4.83,17.69-4.83-9.76,0-17.69-7.93-17.69-17.69v-.11c.06-9.7,7.97-17.57,17.69-17.57s17.69,7.94,17.69,17.69-7.93,17.69-17.69,17.69c8.73,0,16.71,3.22,22.81,8.54,7.32-6.37,11.95-15.76,11.95-26.23"
        />
        <path
          fill="#00a04c"
          d="M261.9,82.17c-6.11-5.32-14.08-8.54-22.81-8.54-6.46,0-12.51,1.77-17.69,4.83-1.82,1.08-3.54,2.32-5.12,3.7,1.59,1.38,3.3,2.62,5.12,3.7,5.18,3.07,11.23,4.83,17.69,4.83,8.73,0,16.71-3.22,22.81-8.54"
        />
        <path
          fill="#d3d800"
          d="M326.66,90.71c-6.46,0-12.51-1.77-17.69-4.83-1.82-1.08-3.54-2.32-5.12-3.7-7.32,6.37-11.95,15.76-11.95,26.23v3.32h17.07v-3.32c0-9.76,7.94-17.69,17.69-17.69"
        />
        <path
          fill="#00a04c"
          d="M303.85,82.17c-7.32-6.37-11.95-15.76-11.95-26.23v52.46c0-10.47,4.63-19.86,11.95-26.23"
        />
        <path
          fill="#0030e8"
          d="M361.42,55.94c0-19.2-15.56-34.76-34.76-34.76s-34.7,15.5-34.76,34.64v.11c0,10.47,4.63,19.86,11.95,26.23,1.59-1.38,3.3-2.62,5.12-3.7,5.18-3.07,11.23-4.83,17.69-4.83-9.76,0-17.69-7.93-17.69-17.69v-.11c.06-9.7,7.97-17.57,17.69-17.57s17.69,7.94,17.69,17.69-7.93,17.69-17.69,17.69c8.73,0,16.71,3.22,22.81,8.54,7.32-6.37,11.95-15.76,11.95-26.23"
        />
        <path
          fill="#00a04c"
          d="M349.48,82.17c-6.11-5.32-14.08-8.54-22.81-8.54-6.46,0-12.51,1.77-17.69,4.83-1.82,1.08-3.54,2.32-5.12,3.7,1.59,1.38,3.3,2.62,5.12,3.7,5.18,3.07,11.23,4.83,17.69,4.83,8.73,0,16.71-3.22,22.81-8.54"
        />
        <path
          fill="#0030e8"
          d="M411.07,20.98c-19.35,0-35.03,15.68-35.03,35.03s15.68,35.03,35.03,35.03,35.03-15.68,35.03-35.03-15.68-35.03-35.03-35.03M411.07,38.19c9.83,0,17.83,8,17.83,17.83s-8,17.83-17.83,17.83-17.83-8-17.83-17.83,8-17.83,17.83-17.83"
        />
        <path
          fill="#e30613"
          d="M446.22,55.99c0,6.46-1.76,12.5-4.83,17.68-1.08,1.82-2.32,3.54-3.7,5.12,6.36,7.32,15.74,11.94,26.21,11.94h3.32v-17.06h-3.32c-9.75,0-17.68-7.93-17.68-17.68"
        />
        <path
          fill="#771712"
          d="M437.69,33.19c-5.31,6.1-8.53,14.07-8.53,22.8,0,6.46,1.76,12.5,4.83,17.68,1.08,1.82,2.32,3.54,3.7,5.12,1.38-1.58,2.62-3.3,3.7-5.12,3.07-5.18,4.83-11.22,4.83-17.68,0-8.72-3.22-16.69-8.53-22.8"
        />
        <path
          fill="#0030e8"
          d="M130.88,20.98c-19.35,0-35.03,15.68-35.03,35.03s15.68,35.03,35.03,35.03,35.03-15.68,35.03-35.03-15.68-35.03-35.03-35.03M130.88,38.19c9.83,0,17.83,8,17.83,17.83s-8,17.83-17.83,17.83-17.83-8-17.83-17.83,8-17.83,17.83-17.83"
        />
        <path
          fill="#e30613"
          d="M166.03,55.99c0,6.46-1.76,12.5-4.83,17.68-1.08,1.82-2.32,3.54-3.7,5.12,6.36,7.32,15.74,11.94,26.21,11.94h3.32v-17.06h-3.32c-9.75,0-17.68-7.93-17.68-17.68"
        />
        <path
          fill="#771712"
          d="M157.5,33.19c-5.31,6.1-8.53,14.07-8.53,22.8,0,6.46,1.76,12.5,4.83,17.68,1.08,1.82,2.32,3.54,3.7,5.12,1.38-1.58,2.62-3.3,3.7-5.12,3.07-5.18,4.83-11.22,4.83-17.68,0-8.72-3.22-16.69-8.53-22.8"
        />
        <rect fill="#0030e8" x="10.26" width="17.06" height="90.47" />
        <rect fill="#0030e8" x="63.2" width="17.06" height="90.47" />
        <path
          fill="#d3d800"
          d="M62.73,47.04c-.08-.05-.16-.09-.23-.13.06.04.12.07.18.1.02.01.03.02.05.03"
        />
        <path
          fill="#d3d800"
          d="M0,29c.2,24.68,20.26,44.64,45,44.64s44.8-19.95,45-44.64h-17.6c-.33,14.58-12.35,26.31-27.16,26.31s-26.84-11.73-27.16-26.31H0Z"
        />
        <path
          fill="#00a04c"
          d="M10.26,57.24c4.55,5.52,10.39,9.94,17.06,12.79v-21.39c-5.54-4.81-9.08-11.81-9.26-19.64h-7.8v28.24Z"
        />
        <path
          fill="none"
          d="M72.39,29c-.32,14.58-12.35,26.31-27.16,26.31s-26.84-11.73-27.16-26.31H0c.2,24.69,20.26,44.64,45,44.64s44.8-19.95,45-44.64h-17.61Z"
        />
      </Box>
    </Box>
  )
}

export default LogoHappa
